/* 🤖 this file was generated by svg-to-ts */
export const siriusCaretLeft: {
  name: 'caret_left';
  data: string;
} = {
  name: 'caret_left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.53 3.97a.75.75 0 0 1 0 1.06L8.56 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 0Z" fill="currentColor"/></svg>`
};
